import {Component, ElementRef, HostListener, OnInit, ViewChild,} from '@angular/core';
import {CoefService} from '../../service/coef.service';
import {FormBuilder} from '@angular/forms';
import {PriceService} from '../../service/price.service';
import {SwiperComponent} from 'angular2-useful-swiper';
import * as Konva from '../../../assets/konva';
import {CoefDoorService} from '../../service/door service/coef-door.service';
import {InitDoorService} from '../../service/door service/init-door.service';
import * as _ from 'lodash';
import {CreateMaterials} from '../../class/doorMaterials/create-materials';
import {DragService} from '../../service/door service/drag.service';
import {CreateService} from '../../service/create.service';
import {ElementsService} from '../../service/elements.service';
import {FADE_IN_OUT} from '../../common/animations';
import {SocketPriceService} from '../../service/socket-price.service';
import {HttpClient} from '@angular/common/http';
import {baseUrl} from '../../router.path';
import {HingedFacadeSection} from '../../class/hinged-facade-section';
import {InitRenderService} from '../../service/renderingService/init-render.service';
@Component({
  selector: 'app-door-stage',
  templateUrl: './door-stage.component.html',
  styleUrls: ['./door-stage.component.css'],
  animations: [FADE_IN_OUT]
})
export class DoorStageComponent implements OnInit {
  @ViewChild('myButton') myButton: ElementRef;
  @ViewChild('myButton2') myButton2: ElementRef;

  public typeMat;
  allMat = [];
  typeDoor;
  selectedValue;
  selectedValue2;
  colorSystem = [];
  textEroor = '';
  typeValue = '';
  img_hover;
  filterName = '';
  type;
  modalsError = false;
  popapCloseCustom = false;
  selectedCities;
  id;
  nameSection;
  nameSectionCustom = 'не вибрано';
  colorSystemModal = false;
  colorSystemName = '';
  saveSystemColorItem:any = false;
  typeSelect = 1;
  countSection ;
  hingedKindWarning = '';
  img_hover_src;
  separation = [];
  img_hover_class = false;
  objectSaveType:any = false;
  systemsDoorId ;
  popapClose = false;
  public doorStage = null;
  config: SwiperOptions = {
    slidesPerView: 2,
    spaceBetween: 5,
    pagination: '.swiper-pagination',
    paginationClickable: true,
    // simulateTouch: false,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
  };
  configs: SwiperOptions = {
    slidesPerView: 4,
    spaceBetween: 5,
    pagination: '.swiper-pagination',
    paginationClickable: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
  };
  configss: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 5,
    pagination: '.swiper-pagination',
    paginationClickable: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
  };
  element = true;
  price;
  door_structure = [];
  @ViewChild('usefulSwiper') usefulSwiper: SwiperComponent;
  @ViewChild('SwiperMat') SwiperMat: SwiperComponent;
  @ViewChild('select') select: ElementRef;

  @HostListener('document:pointermove', ['$event']) onPointerMove(event): void {
    if (!event.target.attributes['data-hover']) {
      this.img_hover_class = false;
      this.img_hover_src = null;
      this.img_hover_class = false;
      return;
    }
    if (event.target.attributes['data-hover'].value === 'width') {
      this.img_hover_src = event.srcElement.currentSrc;
      this.img_hover = true;
      this.img_hover_class = true;
    } else {
      this.img_hover_src = event.srcElement.currentSrc;
      this.img_hover = true;
      this.img_hover_class = false;
    }
  }

  constructor(private formBuilder: FormBuilder,
              public coef: CoefService,
              public coefDoor: CoefDoorService,
              private priceService: PriceService,
              private init_door: InitDoorService,
              private drag: DragService,
              private create: CreateService,
              private socket: SocketPriceService,
              private prices: PriceService,
              private http: HttpClient,
              private elements: ElementsService,
              private render: InitRenderService,
  ) {
    this.socket.price.subscribe((data) => {
      this.price = data ;
    });

  }

  initDoor(doorLayr) {
    if (!this.doorStage) {
      this.doorStage = new Konva.Stage({
        container: 'containers',
        width: this.coef.widthWrapper,
        height: this.coef.heightWrapper
      });
      this.doorStage.add(doorLayr);
      this.systemsDoorId = this.coefDoor.systemId;
      this.getColorSystem(this.coefDoor.colorSystemId)
      this.allMat = _.cloneDeep(this.coefDoor.facade_materials);
      this.generate(this.allMat);

      if (+this.coef.pramsId === 17) {
        // Реєструємо stage у service — це side-effect який зазвичай робить init_door.intDoor.
        // Для type 17 ми intDoor НЕ викликаємо (свій шлях через initHingedRootZones),
        // тому без цього deleteOld не побачить наш stage і не зачистить його при наступному
        // створенні шафи (двойняшки canvas'и у DOM).
        this.coefDoor.getStage({stage: this.doorStage});
        this.initHingedRootZones();
      } else {
        this.init_door.intDoor({stage: this.doorStage});
      }
    }
    this.door_structure = this.coefDoor.door_structure;

  }

  hingedFactory: HingedFacadeSection;

  initHingedRootZones() {
    const cabW = this.coef.setingsWardrobe.width / this.coef.global_coef;
    const cabH = this.coef.setingsWardrobe.height / this.coef.global_coef;
    const centerX = (this.coef.widthWrapper - cabW) / 2;
    const topY = this.coef.topPositaionWrapper;
    this.hingedFactory = new HingedFacadeSection(this.coef, this.coefDoor, this.init_door, () => {
      if (+this.coef.pramsId === 17) {
        this.separation = this.computeHingedSeparation(this.typeSelect);
      }
    }, this.create, this.elements);
    const factory = this.hingedFactory;
    this.coef.hingedFactory = factory;
    const isInset = this.isInsetFacade();
    const stikThreshold = this.coef.min_double_split_width || 2700;
    console.log('[HINGED] initHingedRootZones', {
      cabinetWidthMm: this.coef.setingsWardrobe.width,
      cabinetHeightMm: this.coef.setingsWardrobe.height,
      global_coef: this.coef.global_coef,
      global_size_flat_px: this.coef.global_size_flat,
      height_legs_px: this.coef.height_legs,
      cabW_px: cabW,
      cabH_px: cabH,
      centerX_px: centerX,
      topY_px: topY,
      stikThreshold: stikThreshold,
      isInset: isInset
    });
    if (this.coef.setingsWardrobe.width > stikThreshold) {
      const flat = this.coef.global_size_flat;
      const legs = this.coef.height_legs;
      const hf = this.coef.hingedFacade || {};
      // Для inset зовнішній зазор = facade_gap_size (єдиний з міжфасадним).
      // Для overlay+stik залишаємо 0 — фасади торкаються країв корпусу.
      const sideOffset = isInset ? (hf.facade_gap_size || 0) : 0;
      const topBottomOffset = isInset ? (hf.facade_gap_size || 0) : 0;
      const gapPx = hf.facade_gap_size || 0;
      const coefG_outer = this.coef.global_coef;
      let totalCenter = centerX + cabW / 2;
      const stikCenter_default_mm = totalCenter * coefG_outer;
      const gap_mm = gapPx * coefG_outer;
      const leftFacadeRightEdge_mm = stikCenter_default_mm - gap_mm / 2;
      const frac = leftFacadeRightEdge_mm - Math.floor(leftFacadeRightEdge_mm);
      if (Math.abs(frac - 0.5) < 0.001) {
        totalCenter = (stikCenter_default_mm - 0.5) / coefG_outer;
      } else if (Math.abs(frac) > 0.001) {
        const snapped = Math.round(leftFacadeRightEdge_mm) + gap_mm / 2;
        totalCenter = snapped / coefG_outer;
      }

      factory.drawCabinetOutline('root', centerX, topY, cabW, cabH);

      const facadeY = isInset ? topY + flat + topBottomOffset : topY + topBottomOffset;
      const facadeH = isInset
        ? cabH - 2 * flat - legs - 2 * topBottomOffset
        : cabH - legs - 2 * topBottomOffset;

      const leftX = isInset ? centerX + flat + sideOffset : centerX + sideOffset;
      const leftW = totalCenter - gapPx / 2 - leftX;
      const rightX = totalCenter + gapPx / 2;
      const rightRightEdge = isInset ? centerX + cabW - flat - sideOffset : centerX + cabW - sideOffset;
      const rightW = rightRightEdge - rightX;

      const leftRoot = factory.createFacadeGroup('left', leftX, facadeY, leftW, facadeH, isInset, 1, null, 0);
      const rightRoot = factory.createFacadeGroup('right', rightX, facadeY, rightW, facadeH, isInset, 1, null, 0);

      const stik = factory.createSplitter(leftRoot, rightRoot, 'cols');
      if (stik && stik.attrs && stik.attrs.params) {
        stik.attrs.params.isRootStik = true;
        const coefG2 = this.coef.global_coef;
        const flat2 = this.coef.global_size_flat;
        const cabW2 = this.coef.setingsWardrobe.width / coefG2;
        const cabLeftX = (this.coef.widthWrapper - cabW2) / 2;
        const innerLeftPx = cabLeftX + flat2;
        const innerRightPx = cabLeftX + cabW2 - flat2;
        const splitWidthPx = (this.coef.min_double_split_width || 2700) / coefG2;
        const gapPx2 = (this.coef.hingedFacade && this.coef.hingedFacade.facade_gap_size) || 0;
        const stikXMin = innerRightPx + flat2 - splitWidthPx - gapPx2 / 2;
        const stikXMax = innerLeftPx + splitWidthPx - flat2 - gapPx2 / 2;
        const clampValid = stikXMax > stikXMin;
        const innerBound = stik.dragBoundFunc();
        stik.dragBoundFunc((pos: any) => {
          const constrained = (typeof innerBound === 'function')
            ? innerBound.call(stik, pos)
            : {x: pos.x, y: stik.attrs.y};
          let x = constrained.x;
          if (clampValid) {
            if (x < stikXMin) x = stikXMin;
            if (x > stikXMax) x = stikXMax;
          }
          return {x: x, y: constrained.y};
        });
      }
    } else {
      factory.createRootZone('main', centerX, topY, cabW, cabH, isInset);
    }
    // Edit-режим: дерево фасадів зашите всередину door_count як елемент з visual_only=true.
    // ВАЖЛИВО: button-table компоненти при load'і розпаковують: renderobject.facade_object =
    // res.payload.facade_object.door_count. Тобто у нас render.object.facade_object — це САМ
    // array (а не об'єкт з .door_count). Звідси дістаємо visual_only елемент напряму.
    console.log('[RESTORE-CHECK] entry', {
      has_render: !!this.render,
      rerender: !!(this.render && this.render.rerender),
      has_object: !!(this.render && this.render.object),
      facade_object_is_array: Array.isArray(this.render && this.render.object && this.render.object.facade_object),
      facade_object_length: this.render && this.render.object && Array.isArray(this.render.object.facade_object)
        ? this.render.object.facade_object.length : null,
    });
    if (this.render && this.render.rerender && this.render.object && Array.isArray(this.render.object.facade_object)) {
      const arr = this.render.object.facade_object;
      const visualItem = arr.find((x: any) => x && x.visual_only === true && Array.isArray(x.facade_tree));
      console.log('[RESTORE-CHECK] visualItem', {
        found: !!visualItem,
        tree_length: visualItem && Array.isArray(visualItem.facade_tree) ? visualItem.facade_tree.length : null
      });
      if (visualItem) {
        console.log('[RESTORE-CHECK] calling restoreFromTree with tree:', visualItem.facade_tree);
        factory.restoreFromTree(visualItem.facade_tree);
      }
    }
  }

  isInsetFacade(): boolean {
    const ids = this.coef.init_option_ids || [];
    const result = ids.indexOf(201) !== -1;
    console.log('[HINGED] isInsetFacade via init_option_ids =', ids, '→', {isInset: result, label: result ? 'Внутрішні' : 'Зовнішні'});
    return result;
  }

  getColorSystem(id) {
    if (id) {
      if (!this.coef.arrayNotSystemColor.includes(+this.coef.pramsId)) {
        if (this.coefDoor.colorSystemArray ) {
          for (const color of this.coefDoor.colorSystemArray) {
            if (id == color.id) {
              this.colorSystemName = `${color.name}`;
            }
          }
        }
      }
    }
  }
   removeItemsWithCommonSubId(items,  idDoor) {
    for (let i = items.length - 1; i >= 0; i--) {
      if (items[i].attrs && items[i].attrs.params  && items[i].attrs.params.idDoor === idDoor && !items[i].attrs.params.contours) {
       
        items[i].remove();
      }
    }
  }
  deleteAllDoor(){
    if (+this.coef.pramsId === 17) {
      this.textEroor = 'Скинути всі зміни? Шафа повернеться до початкового стану.';
      this.typeValue = 'deleteAllDoor';
      this.modalsError = true;
      return;
    }
    if(this.typeDoor){
    this.textEroor = 'Видалення дверей  спричинить ситуацію, при якій всі двері будуть скинуті до початкового стану';
    this.typeValue = 'deleteAllDoor';
    this.modalsError = true;
    }

  }
  onModalClosed(event){
    if(!event){
      this.modalsError = false;
      return;
    }
    switch (event){
      case 'deleteAllDoor':
        if (+this.coef.pramsId === 17) {
          this.resetAllHinged();
        } else {
          this.coef.doorsArray.forEach((door,index) => {
            this.deleteOneDoor(index+1)
            })
        }
        break;
      case 'deleteOneDoor':
        this.deleteOneDoor(this.coefDoor.reDesign.attrs.params.idDoor)
        break;
      case 'changeSystem':
        this.changeAllSystem();
        break;
    }
    this.modalsError = false;
  }

  canGoBackToParent(): boolean {
    const reD: any = this.coefDoor.reDesign;
    return !!(reD && reD.attrs && reD.attrs.params && reD.attrs.params.parent);
  }

  goBackToParent() {
    const reD: any = this.coefDoor.reDesign;
    if (!reD || !reD.attrs || !reD.attrs.params || !reD.attrs.params.parent) return;
    const parent = reD.attrs.params.parent;
    if (this.hingedFactory) this.hingedFactory.unsplit(parent);
    this.coefDoor.reDesign = parent;
    this.hingedKindWarning = '';
    this.countSection = 1;
    this.separation = this.computeHingedSeparation(this.typeSelect);
    if (this.init_door && this.init_door.openSlid) {
      this.init_door.openSlid.next({id: 'hinged', obj: parent});
    }
    console.log('[HINGED] goBackToParent', {zoneName: parent.attrs && parent.attrs.params && parent.attrs.params.zoneName});
  }

  facadeColorFilter = '';
  showFacadeColorPicker = false;

  toggleFacadeColorPicker() {
    this.showFacadeColorPicker = !this.showFacadeColorPicker;
    if (!this.showFacadeColorPicker) this.facadeColorFilter = '';
  }

  getCurrentFacadeColorRgb(): string {
    const id = this.getCurrentFacadeColorId();
    if (id == null) return '';
    const list = this.coef.settingsColor || [];
    const found = list.find((c: any) => c.id === +id);
    return found ? found.rgb : '';
  }

  getCurrentFacadeColorName(): string {
    const reD: any = this.coefDoor.reDesign;
    const overridden = reD && reD.attrs && reD.attrs.params && reD.attrs.params.facadeColorId != null;
    const id = this.getCurrentFacadeColorId();
    if (id == null) return 'не вибрано';
    const list = this.coef.settingsColor || [];
    const found = list.find((c: any) => c.id === +id);
    if (!found) return 'не вибрано';
    return overridden ? found.name : found.name + ' (як корпус)';
  }

  getFacadeColors(): any[] {
    const all = this.coef.settingsColor || [];
    const q = (this.facadeColorFilter || '').trim().toLowerCase();
    if (!q) return all;
    return all.filter((c: any) => c && c.name && c.name.toLowerCase().indexOf(q) !== -1);
  }

  getCurrentFacadeColorId(): number | null {
    const reD: any = this.coefDoor.reDesign;
    if (!reD || !reD.attrs || !reD.attrs.params) return null;
    if (reD.attrs.params.facadeColorId != null) return reD.attrs.params.facadeColorId;
    return this.coef.facade_color_id != null ? +this.coef.facade_color_id : null;
  }

  setHingedFacadeColor(id: number) {
    const reD: any = this.coefDoor.reDesign;
    if (!reD || !reD.attrs || !reD.attrs.params) return;
    if (reD.attrs.params.sectionKind === 'open') return;
    reD.attrs.params.facadeColorId = +id;
    // Якщо новий колір НЕ textured — скидаємо напрям полотна (бо для однотону він не має сенсу
    // і його не видно у UI, але без скиду — потрапив би у payload як "невидимий" stale-стан).
    const found = (this.coef.settingsColor || []).find((c: any) => c.id === +id);
    if (!found || !found.textured) {
      reD.attrs.params.isTextureReversed = false;
    }
    if (this.hingedFactory) this.hingedFactory.refreshSizeLabels(reD);
    this.coefDoor.DoorWrapper.batchDraw();
    console.log('[HINGED] setHingedFacadeColor', {id});
  }

  // Чи поточний колір вибраного ліст має текстуру (хвильки + кнопка перевертання).
  isCurrentFacadeColorTextured(): boolean {
    const reD: any = this.coefDoor.reDesign;
    if (!reD || !reD.attrs || !reD.attrs.params) return false;
    if (reD.attrs.params.sectionKind === 'open') return false;
    const id = this.getCurrentFacadeColorId();
    if (id == null) return false;
    const list = this.coef.settingsColor || [];
    const found = list.find((c: any) => c.id === +id);
    return !!(found && found.textured);
  }

  getCurrentFacadeTextureReversed(): boolean {
    const reD: any = this.coefDoor.reDesign;
    if (!reD || !reD.attrs || !reD.attrs.params) return false;
    return !!reD.attrs.params.isTextureReversed;
  }

  toggleHingedFacadeTextureDirection() {
    const reD: any = this.coefDoor.reDesign;
    if (!reD || !reD.attrs || !reD.attrs.params) return;
    if (!this.isCurrentFacadeColorTextured()) return;
    const next = !reD.attrs.params.isTextureReversed;
    if (this.hingedFactory) this.hingedFactory.setFacadeTextureDirection(reD, next);
  }

  getDrawerSubItems(): any[] {
    const map = this.coef.disabledItemMap || {};
    const drawerGroup = map[9];
    if (!drawerGroup || !drawerGroup.subItems) return [];
    const out: any[] = [];
    for (const k in drawerGroup.subItems) {
      if (drawerGroup.subItems.hasOwnProperty(k)) {
        out.push({id: +k, name: drawerGroup.subItems[k].name, active: drawerGroup.subItems[k].active});
      }
    }
    return out;
  }

  getCurrentDrawerSubId(): number | null {
    const reD: any = this.coefDoor.reDesign;
    if (!reD || !reD.attrs || !reD.attrs.params) return null;
    return reD.attrs.params.drawerSubId != null ? reD.attrs.params.drawerSubId : null;
  }

  getDrawerComponentSelector(subId: number): string {
    switch (+subId) {
      case 7: return 'siple';
      case 8: return 'with';
      case 9: return 'sipleLock';
      case 10: return 'withLock';
      case 26: return 'sipleSpec';
      case 27: return 'sipleSpecD';
      default: return 'siple';
    }
  }

  setHingedDrawerSubId(subId: number) {
    const reD: any = this.coefDoor.reDesign;
    if (!reD || !reD.attrs || !reD.attrs.params) return;
    if (reD.attrs.params.sectionKind !== 'drawers') return;
    reD.attrs.params.drawerSubId = +subId;
    // Зона шухляди в корпусі — копія типу з фасаду (йде на бек у content і drawerZoneBind).
    const layer = this.coef.shapesLayerw;
    if (layer && layer.children) {
      for (const c of layer.children) {
        const cp = c && c.attrs && c.attrs.params;
        if (cp && cp.isDrawerZone && cp.doorKey === reD._id) cp.drawerSubId = +subId;
      }
    }
    if (this.hingedFactory) this.hingedFactory.refreshSizeLabels(reD);
    this.coefDoor.DoorWrapper.batchDraw();
    console.log('[HINGED] setHingedDrawerSubId', {subId});
  }

  validateHingedAllTyped(): boolean {
    if (+this.coef.pramsId !== 17 || !this.hingedFactory) return true;
    this.hingedFactory.clearUntypedHighlight();
    const untyped = this.hingedFactory.collectUntypedLeaves();
    if (untyped.length === 0) return true;
    this.hingedFactory.highlightUntyped(untyped);
    this.coef.errorTrigger('Оберіть тип секції для всіх зон і сторону відкривання для всіх дверок (підсвічено червоним). Без цього неможливо перейти далі.');
    return false;
  }

  resetAllHinged() {
    if (this.coefDoor.DoorWrapper && this.coefDoor.DoorWrapper.children) {
      for (let i = this.coefDoor.DoorWrapper.children.length - 1; i >= 0; i--) {
        this.coefDoor.DoorWrapper.children[i].destroy();
      }
    }
    if (this.elements && typeof this.elements.deleteElement === 'function' && this.coef.shapesLayerw) {
      const prev = this.coef.startRemove;
      this.coef.startRemove = true;
      this.coef.hingedPurge = true;
      const snapshot = (this.coef.shapesLayerw.children || []).slice();
      for (const evt of snapshot) {
        try { this.elements.deleteElement(evt, this.coef.shapesLayerw); } catch (e) {}
      }
      this.coef.hingedPurge = false;
      this.coef.startRemove = prev;
    }
    this.coefDoor.reDesign = false;
    this.element = true;
    this.separation = [];
    this.countSection = 1;
    this.typeSelect = 2;
    this.hingedKindWarning = '';
    this.initHingedRootZones();
    if (this.hingedFactory) this.hingedFactory.syncPartitionsToCorpus();
    this.coefDoor.DoorWrapper.batchDraw();
    console.log('[HINGED] resetAllHinged complete');
  }
  changeBlure(type){
    if (+this.coef.pramsId === 17 && this.hingedFactory) {
      this.hingedFactory.cycleHingedSplitter(type);
    } else {
      this.init_door.changeManualTravel(type);
    }
    if (this.myButton && this.myButton.nativeElement) this.myButton.nativeElement.blur();
    if (this.myButton2 && this.myButton2.nativeElement) this.myButton2.nativeElement.blur();
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHinged(event: KeyboardEvent) {
    if (+this.coef.pramsId !== 17) return;
    if (!this.hingedFactory) return;
    if (!this.coef.facadeTabActive) return;
    if (!this.coefDoor.selectedHingedSplitter) return;
    const tag = (event.target as any) && (event.target as any).tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
    switch (event.keyCode) {
      case 37:
        event.preventDefault();
        this.hingedFactory.nudgeSelectedSplitter(-1, 0);
        break;
      case 39:
        event.preventDefault();
        this.hingedFactory.nudgeSelectedSplitter(1, 0);
        break;
      case 38:
        event.preventDefault();
        this.hingedFactory.nudgeSelectedSplitter(0, -1);
        break;
      case 40:
        event.preventDefault();
        this.hingedFactory.nudgeSelectedSplitter(0, 1);
        break;
      case 27:
        event.preventDefault();
        this.hingedFactory.clearHingedSplitterSelection();
        break;
    }
  }
  changeAllSystem(){
    this.coefDoor.DoorWrapper.destroyChildren()
    this.coefDoor.reDesign = false;
    this.coefDoor.manualTravelElement = false;
    this.coefDoor.DoorWrapper.batchDraw();

    this.http.get(baseUrl.api + 'door-systems/' + this.systemsDoorId ).subscribe((res: any) => {
      if (res.success) {
        this.coef.mainSetting.door_additional_size_two = res.payload.door_additional_size_coef_two;
        this.coef.mainSetting.door_additional_size_three = res.payload.door_additional_size_coef_three;
        this.coef.mainSetting.door_additional_size_four = res.payload.door_additional_size_coef_four;
        this.coef.mainSetting.door_additional_size_five = res.payload.door_additional_size_coef_five;
        const oldSystem = this.coefDoor.systemId;
        this.coef.doorSystemsId =  Number(this.systemsDoorId);
        this.coefDoor.systemId =  Number(this.systemsDoorId);
        this.coefDoor.has_top_stopper = res.payload.has_top_stopper;
        this.coefDoor.has_puller = res.payload.has_puller;
      
        
      this.coefDoor.has_bottom_stopper = res.payload.has_bottom_stopper;
      if(res.payload.has_top_stopper && res.payload.has_bottom_stopper){
        this.coefDoor.stoperDoor = 'bottom';
      }else if(res.payload.has_top_stopper && !res.payload.has_bottom_stopper){
        this.coefDoor.stoperDoor = 'top';
      }else if(!res.payload.has_top_stopper && res.payload.has_bottom_stopper){
        this.coefDoor.stoperDoor = 'bottom';
      }else{
        this.coefDoor.stoperDoor = 'none';
      }
      if(!res.payload.has_puller){
        this.coefDoor.puller = false;
      }
      
        this.coefDoor.parsApiSettingsSystem( res.payload , res.payload.facade_materials)
        this.coefDoor.parceSystemColor( res.payload.system_colors)
        this.getColorSystem(this.coefDoor.colorSystemId)
        const selectOpenDoor = this.coef.doorsArray.length;
        let doors = [];
        for (let i = 0; i < selectOpenDoor; i++) {
          if (this.coef.pramsId == 11) {
            doors.push({
              width: this.coef.getOneDoorWidth(selectOpenDoor, this.coef.setingsWardrobe.width, this.coef.setingsWardrobe.depth ) * this.coef.global_coef,
              door_type_id: 3,
              sep_count: 0,
              materials: [4]
            });
          } else {
            doors.push({
              width: this.coef.getOneDoorWidth(selectOpenDoor, this.coef.setingsWardrobe.width, this.coef.setingsWardrobe.depth ) * this.coef.global_coef,
              door_type_id: 2,
              sep_count: 0,
              materials: [2]
            });
          }
        }
        this.coef.doorsArray = doors;
        this.priceService.setDoorOptions(doors);
        let status = true;
        for(const item of this.coef.shapesLayerw.children){
          if( item.attrs&&item.attrs.params){
            if(item.attrs.params.type ==this.coef.id_element.drawer || item.attrs.params.type == this.coef.id_element.open_door || item.attrs.params.type == this.coef.id_element.pantograph){
              const a = this.coef.blockDrawerCentr(true,{left:{attrs:{x:item.attrs.x - this.coef.global_size_flat,width:this.coef.global_size_flat}} , right:{attrs:{x:item.attrs.x + item.attrs.width,}}});
              if(!a){
                status = false;
                break;
              }
            }
          }
        }
        if(!status){
          this.systemsDoorId = oldSystem;
          this.changeAllSystem();
        }
        this.init_door.intDoor({stage: this.doorStage} , true);
      }
    });

  }
  changeStoper(id){
    this.coefDoor.stoperDoor = id;
    this.prices.sendObjectPrice();
  }
  changehas_puller(value){
    this.coefDoor.puller = value;
    this.prices.sendObjectPrice();
  }
  changeSystem(){
    this.textEroor = 'це спричинить ситуацію, при якій всі двері будуть скинуті до початкового стану';
    this.typeValue = 'changeSystem';
    this.modalsError = true;
  }
  textureReversed(type){
if( this.coefDoor.reDesign.attrs.params.isTextureReversed != type){


    if(type ){

      if( this.coefDoor.reDesign.attrs.height * this.coef.global_coef < this.coef.mainSetting.texture_rotation_max_height){
        this.coefDoor.reDesign.attrs.params.isTextureReversed = type;
        if( this.coefDoor.reDesign.className == "Image"){
          this.rotateHtmlImageToBase64(this.coefDoor.reDesign.image(),90 ,(test)=>{
            const newImage = new Image();
            newImage.src = test;
            this.coefDoor.reDesign.image(newImage)
            this.coefDoor.DoorWrapper.batchDraw()
          })
          this.coefDoor.reDesign.attrs.params.texturedV.visible(false)
          this.coefDoor.reDesign.attrs.params.texturedH.visible(true)
        }else{
          this.coefDoor.reDesign.attrs.params.texturedV.visible(false)
          this.coefDoor.reDesign.attrs.params.texturedH.visible(true)
        }
       
      }
    }else{
      this.coefDoor.reDesign.attrs.params.isTextureReversed = type;
      if( this.coefDoor.reDesign.className == "Image"){
        this.rotateHtmlImageToBase64(this.coefDoor.reDesign.image(),90 ,(test)=>{
          const newImage = new Image();
          newImage.src = test;
          this.coefDoor.reDesign.image(newImage)
          this.coefDoor.DoorWrapper.batchDraw()
        })
        this.coefDoor.reDesign.attrs.params.texturedV.visible(true)
        this.coefDoor.reDesign.attrs.params.texturedH.visible(false)
      }else{
        this.coefDoor.reDesign.attrs.params.texturedV.visible(true)
        this.coefDoor.reDesign.attrs.params.texturedH.visible(false)
      }
     
    }
    this.coefDoor.DoorWrapper.batchDraw()
    this.prices.sendObjectPrice();
  }
  }

  rotateHtmlImageToBase64(htmlImage, degrees, callback) {
    // Створіть новий об'єкт зображення
    var img = new Image();
  
    // Встановіть обробник завантаження зображення
    img.onload = function () {
      // Створіть canvas для обернутого зображення
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
  
      // Оберніть зображення
      canvas.width = degrees % 180 === 0 ? img.width : img.height;
      canvas.height = degrees % 180 === 0 ? img.height : img.width;
  
      if (degrees === 90) {
        context.rotate(Math.PI / 2);
        context.drawImage(img, 0, -img.height);
      } else if (degrees === 180) {
        context.rotate(Math.PI);
        context.drawImage(img, -img.width, -img.height);
      } else if (degrees === 270) {
        context.rotate((3 * Math.PI) / 2);
        context.drawImage(img, -img.width, 0);
      } else {
        canvas.width = img.width;
        canvas.height = img.height;
        context.drawImage(img, 0, 0);
      }
  
      // Отримайте base64 зображення з canvas
      var base64 = canvas.toDataURL('image/jpeg'); // Замініть на інший тип, якщо потрібно
  
      // Викличте зворотну функцію та передайте base64
      callback(base64);
    };
    img.crossOrigin = 'Anonymous';
    // Встановіть посилання на зображення об'єкта <img>
    img.src = htmlImage.src;

  }
  

  
  

  deleteOneDoorStart(){
    if(this.typeDoor){
      this.textEroor = 'це спричинить ситуацію, при якій  двері будуть скинуті до початкового стану';
      this.typeValue = 'deleteOneDoor';
      this.modalsError = true;
    }
   
  }
  deleteOneDoor(typeDoor){
    this.removeItemsWithCommonSubId(this.coefDoor.DoorWrapper.children,typeDoor);
    this.coefDoor.reDesign = false;

    this.typeDoor.content = [2];
    const group = this.init_door.findGroup(typeDoor, this.coefDoor.DoorWrapper);
    const mat = this.init_door.findMat(2,1 , this.coefDoor.facade_materials_system)
     const matDef = this.init_door.findMat(mat.id,1 , this.coefDoor.facade_materials)
    new CreateMaterials(this.coefDoor, this.coef, this.drag, this.create, this.prices).defaultMaterials({id:matDef.default_option.id,content:[mat.id]}, group, false);
    this.openModal(true)
    this.coefDoor.DoorWrapper.batchDraw();
  }
  update(id, color, active,name, parentId?) {
    
    this.closePpopap();
    this.objectSaveType = {id:id, color:color, active:active, parentId:parentId}
    this.nameSection = name;
    this.changeSection();
  }
  updateCustom(id, color, active,name, parentId?){
    this.nameSectionCustom = name;
    this.closePpopapCustom();
    this.init_door.changItemCustom(id, color,  parentId);
    this.closePpopapCustom();
  }

  changeSection(){
    if (this.objectSaveType.active) {
      this.init_door.changItem(this.objectSaveType.id, this.objectSaveType.color, this.typeMat, this.objectSaveType.parentId);
      this.nameSectionCustom = 'не вибрано';
      this.objectSaveType = false;
    }
  }
  openModalColor(){
   
    this.colorSystemModal = true;
  }
  test(i) {
    this.nameSection = 'не вибрано';
    this.filterName = '';
    this.objectSaveType = false;
  }
  findeName(e){
    for(const item of  this.coefDoor.facade_materials){
      if (item.id ==e.id){
        for(const sub of item.options){
          if(sub.id == e.obj.attrs.params.id){
            if(e.id == 8 || e.id == 5 ){
              this.nameSection = sub.names;
            }else{
              this.nameSection = sub.name;
            }
          }
        }
      }
    }
  }
  findeNameCustom(e){
  
      if(e.obj.attrs.params.printId){
        for(const sub of  this.coefDoor.print_allowed.options){
         
          if(sub.id == e.obj.attrs.params.printId){
              this.nameSectionCustom = sub.names;
          }
        }
      }else{
        this.nameSectionCustom = 'не вибрано';
      }
        
    
  }
  ngOnInit() {

    this.init_door.openSlid.subscribe((e) => {
      if(e){
        this.element = false;
        if (+this.coef.pramsId === 17) {
          this.typeMat = e['id'];
          this.popapClose = false;
          this.countSection = 1;
          this.hingedKindWarning = '';
          this.separation = this.computeHingedSeparation(this.typeSelect);
          return;
        }
        this.findeName(e);
        this.findeNameCustom(e)
        const type = e['id'];
        this.typeMat = type;
        this.popapClose = false;
        this.createSelect(e);
      }else{
        this.element = true;
      }
    });

  }
  openModalColaps(){
    this.filterName = '';
    this.popapClose = true;
    this.popapCloseCustom = false;
  }
  openModalColapsCustom(){
    this.filterName = '';
    this.popapClose = false;
    this.popapCloseCustom = true;
  }
  canAdd(){
    if(this.coefDoor.reDesign && this.coefDoor.reDesign.attrs && this.coefDoor.reDesign.attrs.params){
      if(this.coefDoor.reDesign.attrs.params.left === "part" || this.coefDoor.reDesign.attrs.params.right === "part"){
        return false;
      }
    }else{
      return false;
    }
    return true;
  }
  canAddH(){
    if(this.coefDoor.reDesign && this.coefDoor.reDesign.attrs && this.coefDoor.reDesign.attrs.params){
      if(this.coefDoor.reDesign.attrs.params.top === "part" || this.coefDoor.reDesign.attrs.params.bottom === "part"){
        return false;
      }
    }else{
      return false;
    }
    return true;
  }
  createCountSelect (typeSelect){
  
    if(typeSelect == 1 ){
      const min_h_section_height = this.coefDoor.glob_settings.min_h_section_height;
      const wrapperHeight = this.coefDoor.reDesign.attrs.height * this.coef.global_coef;
      const max_h_sep_qty = this.coefDoor.glob_settings.max_h_parts_qty;
      const height_one_separator =  this.coefDoor.heightSeparator  ;
      // Обчислюємо доступну висоту для секцій після врахування розділювачів
      const availableHeightForSections = wrapperHeight + height_one_separator;
    
      // Кількість секцій, що поміщаються в доступну висоту
      const sectionsInAvailableHeight = Math.floor(availableHeightForSections / (min_h_section_height + height_one_separator));
  
      // Обмежуємо кількість секцій максимальною кількістю допустимих розділювачів
      const maxSectionsInWrapperHeight = Math.min(sectionsInAvailableHeight, max_h_sep_qty);

      // Повертаємо результат
      const result = Array.from({ length: maxSectionsInWrapperHeight }, (_, index) => index + 1);
      this.separation = result;
      if( this.coefDoor.reDesign.attrs.params.left == 'part' || this.coefDoor.reDesign.attrs.params.right == 'part'){
        if(this.coefDoor.reDesign.attrs.width * this.coef.global_coef < this.coefDoor.glob_settings.min_nested_h_section_width){
          this.separation = []
        }
     }
     if( (this.coefDoor.reDesign.attrs.params.left == 'part' || this.coefDoor.reDesign.attrs.params.right == 'part') && ((this.coefDoor.reDesign.attrs.params.top == 'part'  && this.coefDoor.reDesign.attrs.width != this.coefDoor.reDesign.attrs.params.topElem.attrs.width ) || (this.coefDoor.reDesign.attrs.params.bottom == 'part' && this.coefDoor.reDesign.attrs.width != this.coefDoor.reDesign.attrs.params.bottomElem.attrs.width))){
        this.separation = []               
      }
      if( (this.coefDoor.reDesign.attrs.params.left == 'fence' && this.coefDoor.reDesign.attrs.params.right == 'fence')){
        let count=0;
        for ( const item of this.coefDoor.DoorWrapper.children){
          if(item.attrs && item.attrs.params && item.attrs.width == this.coefDoor.reDesign.attrs.width && this.coefDoor.reDesign.attrs.x == item.attrs.x  && item.attrs.params.part){
            count++;
          }
        }
         if(this.separation.length >= max_h_sep_qty - count ){
          this.separation =  Array.from({ length: max_h_sep_qty - count }, (_, index) => index + 1)
         }            
      }
      if( (this.coefDoor.reDesign.attrs.params.left == 'part' || this.coefDoor.reDesign.attrs.params.right == 'part') && ((this.coefDoor.reDesign.attrs.params.top == 'part'  && this.coefDoor.reDesign.attrs.width == this.coefDoor.reDesign.attrs.params.topElem.attrs.width ) || (this.coefDoor.reDesign.attrs.params.bottom == 'part' && this.coefDoor.reDesign.attrs.width == this.coefDoor.reDesign.attrs.params.bottomElem.attrs.width))){
       let count=0;
        for ( const item of this.coefDoor.DoorWrapper.children){
          if(item.attrs && item.attrs.params && item.attrs.width == this.coefDoor.reDesign.attrs.width && this.coefDoor.reDesign.attrs.x == item.attrs.x  && item.attrs.params.part){
            count++;
          }
        }
         if(this.separation.length >= max_h_sep_qty - count ){
          this.separation =  Array.from({ length: max_h_sep_qty - count }, (_, index) => index + 1)
         }
                   
      }
    
    }else{
    
      const wrapperWidth = this.coefDoor.reDesign.attrs.width * this.coef.global_coef;
      const max_v_parts_qty = this.coefDoor.glob_settings.max_v_parts_qty;
      const min_v_section_width = this.coefDoor.glob_settings.min_v_section_width;
      const height_one_separator =  this.coefDoor.heightSeparator  ;
      const availableHeightForSections = wrapperWidth + height_one_separator;
   
      // Кількість секцій, що поміщаються в доступну висоту
      const sectionsInAvailableHeight = Math.floor(availableHeightForSections / (min_v_section_width + height_one_separator));
     
      // Обмежуємо кількість секцій максимальною кількістю допустимих розділювачів
      const maxSectionsInWrapperHeight = Math.min(sectionsInAvailableHeight, max_v_parts_qty);

      // Повертаємо результат
      const result = Array.from({ length: maxSectionsInWrapperHeight }, (_, index) => index + 1);
      this.separation = result;
   
      if( this.coefDoor.reDesign.attrs.params.top == 'part' || this.coefDoor.reDesign.attrs.params.bottom == 'part'){
        if(this.coefDoor.reDesign.attrs.height * this.coef.global_coef < this.coefDoor.glob_settings.min_nested_v_section_height){
          this.separation = [];
        }
     }
     if( (this.coefDoor.reDesign.attrs.params.top == 'part' || this.coefDoor.reDesign.attrs.params.bottom == 'part') && ((this.coefDoor.reDesign.attrs.params.left == 'part'  && this.coefDoor.reDesign.attrs.height != this.coefDoor.reDesign.attrs.params.leftElem.attrs.height ) || (this.coefDoor.reDesign.attrs.params.right == 'part' && this.coefDoor.reDesign.attrs.height != this.coefDoor.reDesign.attrs.params.rightElem.attrs.height))){
      this.separation = []               
    }
    if( (this.coefDoor.reDesign.attrs.params.top == 'fence' && this.coefDoor.reDesign.attrs.params.bottom == 'fence')){
      let count=0;
      for ( const item of this.coefDoor.DoorWrapper.children){
        if(item.attrs && item.attrs.params && item.attrs.height == this.coefDoor.reDesign.attrs.height && this.coefDoor.reDesign.attrs.y == item.attrs.y  && item.attrs.params.part && item.attrs.params.type == this.coefDoor.reDesign.attrs.params.type){
          count++;
        }
      }
       if(this.separation.length >= max_v_parts_qty - count ){
        this.separation =  Array.from({ length: max_v_parts_qty - count }, (_, index) => index + 1)
       }            
    }
    if( (this.coefDoor.reDesign.attrs.params.top == 'part' || this.coefDoor.reDesign.attrs.params.bottom == 'part') && ((this.coefDoor.reDesign.attrs.params.left == 'part'  && this.coefDoor.reDesign.attrs.height == this.coefDoor.reDesign.attrs.params.leftElem.attrs.height ) || (this.coefDoor.reDesign.attrs.params.right == 'part' && this.coefDoor.reDesign.attrs.height == this.coefDoor.reDesign.attrs.params.rightElem.attrs.height))){
     let count=0;
      for ( const item of this.coefDoor.DoorWrapper.children){
        if(item.attrs && item.attrs.params && item.attrs.height == this.coefDoor.reDesign.attrs.height && this.coefDoor.reDesign.attrs.y == item.attrs.y  && item.attrs.params.part && item.attrs.params.type == this.coefDoor.reDesign.attrs.params.type){
          count++;
        }
      }
       if(this.separation.length >= max_v_parts_qty - count ){
        this.separation =  Array.from({ length: max_v_parts_qty - count }, (_, index) => index + 1)
       }
                 
    }
    }
  }
  createSelect(e) {
    const typeDoor = this.findDoorType(e.obj.attrs.params.typeDoor);
  
    
    this.createCountSelect(this.typeSelect)

    if (typeDoor) {
      this.typeDoor = _.cloneDeep(typeDoor);
      this.typeDoor.type = e.obj.attrs.params.type;
    } else {
      this.typeDoor = false;
    }
  }

  firsElement = false;

  computeHingedSeparation(typeSelect): number[] {
    const reD: any = this.coefDoor.reDesign;
    if (!reD || !reD.children || !reD.children[0]) return [];
    const params = reD.attrs && reD.attrs.params;
    const dir: 'rows' | 'cols' = +typeSelect === 1 ? 'rows' : 'cols';
    if (params && params.sectionKind) {
      return [];
    }
    const facade = reD.children[0];
    const pw = facade.attrs.width;
    const ph = facade.attrs.height;
    const hf = this.coef.hingedFacade || {};
    const gap = hf.facade_gap_size || 0;
    const total = +typeSelect === 1 ? ph : pw;
    const minSize = this.hingedFactory
      ? this.hingedFactory.getLowestMinAcrossKinds(+typeSelect === 1 ? 'height' : 'width')
      : (+typeSelect === 1 ? (hf.min_open_section_height || 0) : (hf.min_open_section_width || 0));
    if (!minSize || total <= 0) return [];
    const maxN = Math.floor((total + gap) / (minSize + gap));
    if (maxN < 2) return [];
    const arr = [];
    for (let n = 2; n <= maxN; n++) arr.push(n);
    console.log('[HINGED] computeHingedSeparation', {
      typeSelect, total_px: total, gap_px: gap, minSize_px: minSize, range: arr
    });
    return arr;
  }

  // Type 17: групи init_types, які дублюємо з першого кроку у "Загальні налаштування" дверей
  // (10 — марка завіс, 11 — тип кріплення). На калькулятор не впливають — лише для бека
  // через init_option_ids.
  hingeSettingsGroupIds = [10, 11];

  getHingeSettingsGroups(): any[] {
    const initTypes: any[] = (this.coef.setingsWardrobe && this.coef.setingsWardrobe.init_types) || [];
    return initTypes.filter((t: any) => t && this.hingeSettingsGroupIds.indexOf(t.id) !== -1);
  }

  // Той самий select.value що й на першому кроці + заміна id групи в init_option_ids.
  // Вибране значення беремо з coef.init_option_ids (саме воно йде на бек), а не з group.value:
  // setingsWardrobe — копія з першого Далі, у якій first-stage ngOnChanges скидає value до дефолтів.
  getHingeSettingsValue(group: any): number | null {
    const optionIds = ((group && group.options) || []).map((o: any) => +o.id);
    const id = (this.coef.init_option_ids || []).find((v: any) => optionIds.indexOf(+v) !== -1);
    return id != null ? +id : null;
  }

  setHingeSettingsOption(group: any, id: number) {
    if (!group || id == null) return;
    group.value = id;
    const optionIds = (group.options || []).map((o: any) => +o.id);
    const ids: number[] = this.coef.init_option_ids || (this.coef.init_option_ids = []);
    const idx = ids.findIndex((v: any) => optionIds.indexOf(+v) !== -1);
    if (idx !== -1) ids[idx] = +id;
    else ids.push(+id);
    this.prices.sendObjectPrice();
  }

  // Тип відкривання дверки (лише двері): 'common' | 'push-up' | 'soft-close'.
  getOpeningType(): string {
    const reD: any = this.coefDoor.reDesign;
    return (reD && reD.attrs && reD.attrs.params && reD.attrs.params.openingType) || 'common';
  }

  setOpeningType(type: string) {
    const reD: any = this.coefDoor.reDesign;
    if (!reD || !reD.attrs || !reD.attrs.params) return;
    if (reD.attrs.params.sectionKind !== 'door') return;
    if (this.hingedFactory) this.hingedFactory.setOpeningType(reD, type);
    else { reD.attrs.params.openingType = type; this.coefDoor.DoorWrapper.batchDraw(); }
  }

  setHingedSwingDir(dir: string) {
    this.hingedKindWarning = '';
    const reD: any = this.coefDoor.reDesign;
    if (!reD || !reD.attrs || !reD.attrs.params) return;
    if (reD.attrs.params.sectionKind !== 'door') return;
    const facade = reD.children && reD.children[0];
    if (!facade) return;

    const orient: 'horizontal' | 'vertical' = (dir === 'left' || dir === 'right') ? 'vertical' : 'horizontal';
    const hf = this.coef.hingedFacade || {};
    const minW = orient === 'horizontal' ? (hf.min_horizontal_facade_width || 0) : (hf.min_vertical_facade_width || 0);
    const maxW = orient === 'horizontal'
      ? (hf.max_horizontal_facade_width != null ? hf.max_horizontal_facade_width : Infinity)
      : (hf.max_vertical_facade_width != null ? hf.max_vertical_facade_width : Infinity);
    const minH = orient === 'horizontal' ? (hf.min_horizontal_facade_height || 0) : (hf.min_vertical_facade_height || 0);
    const maxH = orient === 'horizontal'
      ? (hf.max_horizontal_facade_height != null ? hf.max_horizontal_facade_height : Infinity)
      : (hf.max_vertical_facade_height != null ? hf.max_vertical_facade_height : Infinity);

    const wPx = facade.attrs.width;
    const hPx = facade.attrs.height;
    const tooSmallW = wPx < minW;
    const tooBigW = maxW !== Infinity && wPx > maxW;
    const tooSmallH = hPx < minH;
    const tooBigH = maxH !== Infinity && hPx > maxH;

    if (tooSmallW || tooBigW || tooSmallH || tooBigH) {
      const coefG = this.coef.global_coef;
      const wMm = Math.round(wPx * coefG);
      const hMm = Math.round(hPx * coefG);
      const minWmm = Math.round(minW * coefG);
      const maxWmm = maxW === Infinity ? '∞' : Math.round(maxW * coefG);
      const minHmm = Math.round(minH * coefG);
      const maxHmm = maxH === Infinity ? '∞' : Math.round(maxH * coefG);
      const orientLabel = orient === 'horizontal' ? 'горизонтальний' : 'вертикальний';
      this.hingedKindWarning = `Не можна обрати такий напрям відкривання (${orientLabel} фасад). Допустимий розмір: ширина ${minWmm}–${maxWmm} мм, висота ${minHmm}–${maxHmm} мм. Поточний: ${wMm}×${hMm} мм.`;
      console.log('[HINGED] setHingedSwingDir blocked', {dir, orient, current: {w: wMm, h: hMm}});
      return;
    }

    if (this.hingedFactory) this.hingedFactory.applySwingDir(reD, dir);
    else { reD.attrs.params.swingDir = dir; this.coefDoor.DoorWrapper.batchDraw(); }
    console.log('[HINGED] setHingedSwingDir', {dir, orient, zone: reD.attrs.params.zoneName});
  }

  hingedKindLimitsPx(kind: 'door' | 'open' | 'drawers', leafParams: any) {
    const hf = this.coef.hingedFacade || {};
    if (kind === 'open') {
      return {
        minW: hf.min_open_section_width || 0,
        maxW: Infinity,
        minH: hf.min_open_section_height || 0,
        maxH: Infinity
      };
    }
    if (kind === 'drawers') {
      return {
        minW: hf.min_outer_shuttle_facade_width || 0,
        maxW: hf.max_outer_shuttle_facade_width != null ? hf.max_outer_shuttle_facade_width : Infinity,
        minH: hf.min_outer_shuttle_facade_height || 0,
        maxH: hf.max_outer_shuttle_facade_height != null ? hf.max_outer_shuttle_facade_height : Infinity
      };
    }
    const sd = leafParams && leafParams.swingDir;
    const isVertical = sd === 'left' || sd === 'right';
    const isHorizontal = sd === 'up' || sd === 'down';
    if (!isHorizontal && !isVertical) {
      return {
        minW: hf.min_open_section_width || 0,
        maxW: Infinity,
        minH: hf.min_open_section_height || 0,
        maxH: Infinity
      };
    }
    if (isHorizontal) {
      return {
        minW: hf.min_horizontal_facade_width || 0,
        maxW: hf.max_horizontal_facade_width != null ? hf.max_horizontal_facade_width : Infinity,
        minH: hf.min_horizontal_facade_height || 0,
        maxH: hf.max_horizontal_facade_height != null ? hf.max_horizontal_facade_height : Infinity
      };
    }
    return {
      minW: hf.min_vertical_facade_width || 0,
      maxW: hf.max_vertical_facade_width != null ? hf.max_vertical_facade_width : Infinity,
      minH: hf.min_vertical_facade_height || 0,
      maxH: hf.max_vertical_facade_height != null ? hf.max_vertical_facade_height : Infinity
    };
  }

  setHingedKind(kind: 'door' | 'open' | 'drawers') {
    this.hingedKindWarning = '';
    const reD: any = this.coefDoor.reDesign;
    if (!reD || !reD.children || !reD.children[0]) return;
    const params = reD.attrs && reD.attrs.params;
    if (!params || params.isContainer) return;

    const facade = reD.children[0];
    const wPx = facade.attrs.width;
    const hPx = facade.attrs.height;
    const coefG = this.coef.global_coef;
    const wMm = Math.round(wPx * coefG);
    const hMm = Math.round(hPx * coefG);

    // Двері без обраної сторони: розмір має підходити хоча б під вертикальну або горизонтальну
    // дверку, інакше потім жодну сторону відкривання не вибрати.
    if (kind === 'door' && !params.swingDir) {
      const fits = (l: any) => wPx >= l.minW && (l.maxW === Infinity || wPx <= l.maxW)
        && hPx >= l.minH && (l.maxH === Infinity || hPx <= l.maxH);
      const range = (l: any) => {
        const mm = (v: number) => v === Infinity ? '∞' : Math.round(v * coefG);
        return `ширина ${mm(l.minW)}–${mm(l.maxW)} мм, висота ${mm(l.minH)}–${mm(l.maxH)} мм`;
      };
      const vLims = this.hingedKindLimitsPx('door', {swingDir: 'left'});
      const hLims = this.hingedKindLimitsPx('door', {swingDir: 'up'});
      if (!fits(vLims) && !fits(hLims)) {
        this.hingedKindWarning = `Не можна перетворити на "Двері". Допустимий розмір: вертикальні — ${range(vLims)}; горизонтальні — ${range(hLims)}. Поточний: ${wMm}×${hMm} мм.`;
        console.log('[HINGED] setHingedKind blocked: door fits no orientation', {current: {w: wMm, h: hMm}});
        return;
      }
    }

    const lims = this.hingedKindLimitsPx(kind, params);
    const tooSmallW = wPx < lims.minW;
    const tooBigW = lims.maxW !== Infinity && wPx > lims.maxW;
    const tooSmallH = hPx < lims.minH;
    const tooBigH = lims.maxH !== Infinity && hPx > lims.maxH;

    if (tooSmallW || tooBigW || tooSmallH || tooBigH) {
      const labels = {door: 'Двері', open: 'Відкрита', drawers: 'Шухляди', fixed: 'Фіксована'};
      const minWmm = Math.round(lims.minW * coefG);
      const maxWmm = lims.maxW === Infinity ? '∞' : Math.round(lims.maxW * coefG);
      const minHmm = Math.round(lims.minH * coefG);
      const maxHmm = lims.maxH === Infinity ? '∞' : Math.round(lims.maxH * coefG);
      this.hingedKindWarning = `Не можна перетворити на "${labels[kind]}". Допустимий розмір: ширина ${minWmm}–${maxWmm} мм, висота ${minHmm}–${maxHmm} мм. Поточний: ${wMm}×${hMm} мм.`;
      console.log('[HINGED] setHingedKind blocked', {kind, current: {w: wMm, h: hMm}, limits: lims});
      return;
    }

    if (kind === 'drawers' && params.drawerSubId == null) {
      const subs = this.getDrawerSubItems().filter(s => s.active);
      if (subs.length > 0) {
        params.drawerSubId = +subs[0].id;
      }
    }
    if (this.hingedFactory) {
      this.hingedFactory.applySectionKind(reD, kind);
    } else {
      params.sectionKind = kind;
      if (kind !== 'door') params.swingDir = null;
      this.coefDoor.DoorWrapper.batchDraw();
    }
    console.log('[HINGED] setHingedKind', {kind, w: wMm, h: hMm, drawerSubId: params.drawerSubId});
    this.separation = this.computeHingedSeparation(this.typeSelect);
  }

  clearHingedKind() {
    const reD: any = this.coefDoor.reDesign;
    if (!reD || !reD.attrs || !reD.attrs.params) return;
    if (this.hingedFactory) {
      this.hingedFactory.applySectionKind(reD, null);
    } else {
      reD.attrs.params.sectionKind = null;
      reD.attrs.params.swingDir = null;
      this.coefDoor.DoorWrapper.batchDraw();
    }
    // Повний reset секції — також скидаємо тип відкривання.
    reD.attrs.params.openingType = null;
    this.hingedKindWarning = '';
    this.countSection = 1;
    this.separation = this.computeHingedSeparation(this.typeSelect);
    console.log('[HINGED] clearHingedKind');
  }

  hingedSplitTrigger() {
    if (!this.hingedFactory || !this.coefDoor.reDesign) return;
    const params = this.coefDoor.reDesign.attrs && this.coefDoor.reDesign.attrs.params;
    const dir: 'rows' | 'cols' = +this.typeSelect === 1 ? 'rows' : 'cols';
    if (params && params.sectionKind) {
      console.log('[HINGED] split blocked: section already has kind', {kind: params.sectionKind});
      return;
    }
    const fresh = this.computeHingedSeparation(this.typeSelect);
    if (fresh.indexOf(+this.countSection) === -1) {
      console.log('[HINGED] split blocked: count not valid for current zone', {count: +this.countSection, fresh});
      return;
    }
    console.log('[HINGED] splitTrigger', {direction: dir, count: +this.countSection, depth: params && params.depth});
    this.hingedFactory.splitInto(this.coefDoor.reDesign, dir, +this.countSection);
    this.coefDoor.reDesign = false;
    this.element = true;
    this.countSection = 1;
  }

  count(count) {

    if (+this.coef.pramsId === 17) {
      this.hingedSplitTrigger();
      return;
    }
    if(this.countSection != 1){
     this.openModal(true)
    if(this.typeSelect == 1){
      const arrayCount = this.pars_separation(this.countSection, 2);
      this.typeDoor.content = arrayCount;
      const group = this.init_door.findGroup(this.typeDoor.type, this.coefDoor.DoorWrapper);
      new CreateMaterials(this.coefDoor, this.coef, this.drag, this.create, this.prices).defaultMaterials(this.typeDoor, group, false);
      this.select.nativeElement.blur();
      if(count){
        count.selected = true;
      }
    }else{
   
      const group = this.init_door.findGroup(this.typeDoor.type, this.coefDoor.DoorWrapper);
   
      new CreateMaterials(this.coefDoor, this.coef, this.drag, this.create, this.prices).defaultMaterialsV(this.typeDoor, group,this.countSection, false);
      this.select.nativeElement.blur();
      if(count){
        count.selected = true;
      }
      
    }
   
    this.countSection = 1;
  }
  }

  count2() {

    if (+this.coef.pramsId === 17) {
      this.separation = this.computeHingedSeparation(this.typeSelect);
      this.countSection = 1;
      return;
    }
    this.createCountSelect(this.typeSelect)
    this.countSection = 1;
  }

  pars_separation(max, idMat) {
    const array = [];
    for (let i = 1; i <= max; i++) {
      array.push(idMat);
    }
    return array;
  }


  findDoorType(id) {
    return {id:31,content:[2]}
  }

  generate(array) {
    // for (let mat of array) {
    //   if (mat.id !== 8 && mat.id !== 5) {
    //     const newArray = [];
    //     let oneArray = [];
    //     for (let i = 0; i < mat.options.length; i++) {
    //       oneArray.push(mat.options[i]);
    //       if (i != 0) {
    //         if (((i + 1) % 6) === 0) {
    //           newArray.push(oneArray);
    //           oneArray = [];
    //         }
    //       }
    //     }
    //     if (oneArray.length > 0 && oneArray.length < 6) {
    //       newArray.push(oneArray);
    //       oneArray = [];
    //     }
    //     mat.options = newArray;
    //   }
    // }
  }


  openModal(element) {
    if(!this.coefDoor.reDesign && !element ){
      
    }else{
      this.element = element
    }
   
    this.getColorSystem(this.coefDoor.colorSystemId)
    this.saveSystemColorItem = false;
    this.systemsDoorId = this.coefDoor.systemId;
    if (this.usefulSwiper) {
      this.usefulSwiper.swiper.update();
    }
  }

  onDragStart(e) {

  }

  onDragMove(e) {

  }

 

  findtoID(array, id) {
    for (const item of array) {
      if (item.id === id) {
        return item;
      }
    }
    return false;
  }

  updateColorSystem() {
    if (this.saveSystemColorItem.active) {
      this.coefDoor.colorSystem = this.saveSystemColorItem.rgb;
      this.coefDoor.colorSystemId = this.saveSystemColorItem.id;
      for (const elem of this.coefDoor.DoorWrapper.children) {
        if (elem.nodeType === 'Group' && elem.attrs.params && elem.attrs.params.type && !elem.attrs.params.remove) {
          for (const element of elem.children) {
            element.fill(this.coefDoor.colorSystem);
          }
        }
        if (elem.attrs.params && elem.attrs.params.part) {
          elem.fill(this.coefDoor.colorSystem);
        }
      }
      this.coefDoor.DoorWrapper.batchDraw();
        this.prices.sendObjectPrice();

    }
  }
  sendPrice(){
    
    this.prices.sendObjectPrice();
  }
  saveColorSystem(id, rgb, active){
    this.saveSystemColorItem = {active:active,rgb:rgb,id:id};
    this.getColorSystem(id)
  
    this.colorSystemModal = false;
  }
  closePpopap() {
    this.popapClose = false;
  }
  closePpopapCustom() {
    this.popapClose = false;
    this.popapCloseCustom = false;
  }
}
